var map = {
	"./ansar.png": "5334",
	"./ayandeh.png": "792c",
	"./central-bank.png": "1c25",
	"./dey.png": "266d",
	"./eghtesad-novin.png": "ba84",
	"./gardeshgari.png": "1557",
	"./ghavamin.png": "844b",
	"./hekmat-iranian.png": "065a",
	"./iran-venezuela.png": "c80a",
	"./iran-zamin.png": "0ac5",
	"./karafarin.png": "c2c4",
	"./keshavarzi.png": "2056",
	"./maskan.png": "f07b",
	"./mehr-iran.png": "24bf",
	"./mellat.png": "1c75",
	"./melli.png": "55da",
	"./parsian.png": "18fc",
	"./pasargad.png": "d755",
	"./post.png": "d67a",
	"./refah.png": "6815",
	"./resalat.png": "7370",
	"./saderat.png": "755a",
	"./saman.png": "b166",
	"./sanat-o-madan.png": "9d20",
	"./sarmayeh.png": "4062",
	"./sepah.png": "c9f4",
	"./shahr.png": "bec6",
	"./sina.png": "571e",
	"./tejarat.png": "258c",
	"./toose-taavon.png": "674a",
	"./tosee-saderat.png": "8913",
	"./tosee.png": "1b6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff30";